/**
 *  발급받을 유저를 선택해주세요.
 */
export const INVALID_REQUIRED_SELECT_USER_MESSAGE = '발급받을 유저를 선택해주세요.';

/**
 *  일괄 설정 할 포인트 내역 종류, 적립/사용처, 액수를 설정해주세요.
 */
export const INVALID_REQUIRED_BULK_APPLY_POINT_DATA_MESSAGE =
  '일괄 설정 할 포인트 내역 종류, 적립/사용처, 액수를 설정해주세요.';
